export const APIENDPOINTS = {

  FileUpload: '/api/file/offer/public',
  Classifications_Lookup: '/api/classifications',
  CreditOffer: '/api/creditOffer/public',
  Landholders: '/api/creditOffer/landholder',
  offerDeclaration: '/api/creditOffer/credit/',
  WantedCredits: '/api/wantedcredits/snapshot/search',
  UserBaseUrl: '/api/external/User',
  Lookup: '/api/lookup',
  CreditPrograms: '/api/creditOffer/programs',
  ActivePrograms: '/api/program/active',
  TradingGroups: '/api/wantedcredits/snapshot/tradinggroups',
  PrepareOffer:'/api/AnonymousRequest/publicoffer/',
  RegisterTooltip: '/api/Tooltip/register/',

  //Contact
  UPDATE_APPLICANT_CONTACT: `/api/applicant/contact/{id}/`,

  //details
  UPDATE_APPLICANT_DETAILS: `/api/applicant/details/{id}/`,
  GET_APPLICANT_DETAILS: `/api/applicant/{id}`,

  //QUOTES
  QUOTE_APPLICATION: '/api/quoteapplication',
  CREATE_QUOTE_APPLICATION: '/api/quoteapplication',
  SUBMIT_QUOTE_APPLICATION: '/api/quoteapplication/submit',
  UPDATE_QUOTE_APPLICATION: '/api/quoteapplication/{id}',
  GET_QUOTE_APPLICATION: '/api/quoteapplication/{id}',
  GET_ALL_QUOTE_APPLICATION: '/api/quoteapplication',
  UPLOAD_QUOTE_FILE: '/api/File/quoteapplication/{id}',
  UPLOAD_RTMP_FILE: '/api/File/rtmp/{id}',
  DOWNLOAD_QUOTE_FILE: '/api/File/quoteapplication/document/{id}',
   DOWNLOAD_QUOTE_STATEMENT: '/api/File/developer/quote/{id}',

   DOWNLOAD_QUOTE_RFQ: '/api/File/quote/rfq/{referenceNumber}/{id}',
    DOWNLOAD_RTMP: '/api/File/payment/rtmp/{referenceNumber}/{id}',
    DOWNLOAD_PAYMENT_CERTIFICATE: '/api/File/payment/certificate/{referenceNumber}/{id}',
   QUOTE_OBLIGATION_URL: '/api/quoteapplication/obligations/{id}',
  OBLIGATION_PAYMENT_CERTIFICATE_MAIL_SENT: '/api/obligationpaymentreview/certificatemailsent/{id}',

  //QUOTE_CREDIT
  GET_QUOTE_CREDIT: '/api/quoteapplication/credit/{id}',
  ADD_QUOTE_CREDIT: '/api/quoteapplication/{id}/credit',
  UPDATE_QUOTE_CREDIT: '/api/quoteapplication/credit/{id}',
  DELETE_QUOTE_CREDIT: '/api/quoteapplication/quotecredit/{id}',
  UPDATE_QUOTE_QUOTECREDIT: '/api/quoteapplication/quotecredit/{id}',
  OBLIGATION_PAYMENT: '/api/obligationpayment/{id}',
  OBLIGATION_PAYMENT_OBLIGATIONS: '/api/obligationpayment/{id}/obligations',
}

export const APPLICATION_TYPE = {
  JSON: 'application/json',
  PDF: 'application/pdf',
  CSV: 'application/octet-stream',
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  TEXT: 'text/plain',
  JPEG: 'image/jpeg',
  GIF: 'image/gif',
  PNG: 'image/png',
}

export const HEADERS = {
  AUTHORIZATION: 'Authorization',
  CONTENT_TYPE: 'Content-Type',
  ALLOW_ORIGIN: 'Access-Control-Allow-Origin'
}

export const ROUTES = Object.freeze({
  wantedCredits: 'wanted-credits',
  creditOffer: 'credit-offer',
  confirm: 'confirm',
  confirmCreditOffer: 'credit-confirm/:offerNumber',
  userAccountStatus: 'account-status',
  userAccountProfile: 'account-profile',
  creditPruchase: 'credit-purchase',
  offsetsPayment: 'offsets-payments',
  authenticationRedirect: 'auth',
  home: ''
});

